import { useHydrateAtoms } from 'jotai/utils';
import { ReactNode } from 'react';
import { metricFilterMappingEnabledAtom } from '@/atoms/metric/metricFilterMapping';
import { useMetricFilterMappingFeature } from '@/hooks/featureFlags/useMetricFilterMappingFeature';

// hydrates during render, so the vis queries see the mode before their first fetch; needs a ScopeProvider
// scoping metricFilterMappingEnabledAtom, so the mode stays on the vis page
export const HydrateMetricFilterMapping = ({ children }: { children: ReactNode }): ReactNode => {
  const isEnabled = useMetricFilterMappingFeature();
  useHydrateAtoms([[metricFilterMappingEnabledAtom, isEnabled]]);
  return children;
};
